module.exports = __webpack_public_path__ + "img/img29.02750f93.svg";